/**
 * Maps a Google Fonts API variant key (e.g. "700italic", "regular")
 * to the corresponding CSS font-weight and font-style values.
 *
 * General rule:
 * - Strip "italic" suffix → style = "italic", otherwise "normal"
 * - Remaining string is the weight; "regular" = "400"
 */
export function parseVariantKey(variant: string): { weight: string; style: string } {
	const isItalic = variant.endsWith('italic')
	const style = isItalic ? 'italic' : 'normal'

	let weight = isItalic ? variant.slice(0, -6) : variant
	if (weight === 'regular' || weight === '') {
		weight = '400'
	}

	return { weight, style }
}

/**
 * Builds the variant key from CSS weight + style values.
 * Inverse of parseVariantKey.
 */
export function buildVariantKey(weight: string | number, style: string = 'normal'): string {
	const w = String(weight)
	const isItalic = style === 'italic'

	if (w === '400') {
		return isItalic ? 'italic' : 'regular'
	}

	return isItalic ? `${w}italic` : w
}
